export const dashboardEn = {
  title: "Dashboard",
  view_label: "Dashboard view",
  view_me: "Me",
  view_team: "Team",
  kpi: {
    dials_today: "Calls today",
    contacts_today: "Contacts today",
    demos_week: "Demos this week",
    callbacks_due: "Callbacks due",
    overdue_count: "%{smart_count} overdue |||| %{smart_count} overdue",
    tasks_overdue: "Overdue tasks",
    team_dials: "Calls",
    team_contacts: "Contacts",
    contact_rate: "Contact rate",
    team_demos: "Demos",
    pipeline_value: "Pipeline value",
    weighted: "Weighted: %{amount}",
    won_month: "Won this month",
  },
  ready_to_call: "Ready to call?",
  start_calling: "Start calling",
  queue_size: "%{size} in queue",
  callbacks_title: "My callbacks today",
  no_callbacks: "No callbacks today 🎉",
  overdue: "overdue",
  call: "Call",
  call_company: "Call %{name}",
  // GAVION off-CRM call: a callback made from a cell
  off_crm: "Made outside the CRM",
  off_crm_company: "Log a call made outside the CRM to %{name}",
  demos_title: "My upcoming demos",
  no_demos: "No demo in the next 7 days.",
  my_activity: "My activity (14 days)",
  dials: "Calls",
  contacts: "Contacts",
  sparkline_aria: "%{label}: %{total} over %{days} days",
  leaderboard: {
    title: "Rep leaderboard",
    rep: "Rep",
    dials: "Calls",
    contacts: "Contacts",
    demos: "Demos",
    talk_time: "Talk time",
    dials_per_hour: "Calls / h in session",
    empty: "No calls today.",
  },
  funnel_title: "This month's funnel",
  funnel_empty: "No deal created this month.",
  funnel_link: "See the full report",
  health: {
    title: "Integrations",
    all_ok: "All systems OK",
    levels: { warn: "needs attention", error: "failing" },
    providers: {
      microsoft: "Microsoft 365",
      granola: "Granola",
      voipms: "VoIP.ms",
      ses: "Email (SES)",
    },
  },
};
